module.exports = __webpack_public_path__ + "static/media/tictactoe.702a85ac.png";